import { Button, IconButton, useMediaQuery, useTheme } from "@mui/material";

import { useTranslate } from "src/locales";

import Iconify from "src/components/iconify";
import { openUserFeedbackDialog } from "src/store/slices/app/appSlice";
import { useAppDispatch } from "src/store/store";

export const FeedbackButton = () => {

  const { t } = useTranslate();

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const dispatch = useAppDispatch();

  const handleClick = async (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    dispatch(openUserFeedbackDialog());
  };

  if (isMobile) {
    return (
      <IconButton
        color="primary"
        onClick={handleClick}
      >
        <Iconify icon="mdi:comment-text-outline" />
      </IconButton>
    );
  }

  return (
    <Button
      variant='contained'
      color="secondary"
      startIcon={<Iconify icon="mdi:comment-text-outline" />}
      onClick={handleClick}
    >
      {t('components.user_feedback_dialog.provide')}
    </Button>
  );
}